/* globals $, SCS, debug */


// ************************************************************************
// Tracking implementation and helpers
// ************************************************************************

// some trackings are called very early and there is a high chance
// tealium and the datalayer are not yet initialized. Queue these
// calls and execute them once datalayer/tealium is initialized.
// newer versions will support getAnalyticsPageName(callback)
var trackingQueue = [];
var scheduledCheck = false;

// return if tealium and datalayer are ready
function isTrackingReady() {
	return SCS.tealium && SCS.tealium.isReady()
		&& SCS.datalayer.getAnalyticsPageName
		&& SCS.datalayer.getAnalyticsPageName();
}

// check if tracking is ready and process queued events
// ToDo: datalayer should offer us a callback hook!
function checkTrackingState() {
	if (isTrackingReady()) {
		processTrackingQueue();
	} else if (!scheduledCheck) {
		scheduledCheck = true;
		setTimeout(function () {
			scheduledCheck = false;
			checkTrackingState();
		}, 80);
		debug.log('res-sme-cbu-popup: waiting for datalayer');
	}
}

// process all queued tracking events
function processTrackingQueue() {
	var location = SCS.datalayer.getAnalyticsPageName();
	while (trackingQueue.length > 0) {
		var data = trackingQueue.shift();
		debug.log('res-sme-cbu-popup: process queued tracking', location, data);
		SCS.portal.datalayer.trackEvent(data.action, data.label, location, data.category);
	}
}

// track as soon as tealium/datalayer is ready
function trackDefered(action, label, category) {
	trackingQueue.push({
		action: action,
		label: label,
		category: category
	});
	checkTrackingState();
}

// ************************************************************************
// Dialog implementation
// ************************************************************************
var modal = require('lib/generic/SDXModalDialog').default;
var Segment = require('lib/ecommerce/util').Segment;
// ************************************************************************

var user = undefined;
var userBox = undefined;
require('lib/personalization/profile').getProfile().then(function(profile) {
	// Wait for DOMContentLoaded to ensure UserBox is available
	$(function ready() {
		userBox = require('lib/personalization/Tc.Module.UserBox').getGlobalUserBox();
		user = profile.getUser();
		var userSegment;
		var labelSegment;

		if(user) {
			// Get user segment from user profile
			userSegment = user.getSegment();
			if (typeof(userSegment) !== 'string') return;
			userSegment = userSegment.toLowerCase();
			labelSegment = userSegment !== 'res' ? 'biz' : 'res';
			handleLoginState(userSegment, true);

			// Set cookie so we have segment information (from previous login)
			// When user is not logged in (sometimes also known as SME Cookie)
			jQuery.cookie('SCSUserSegment', userSegment, {
				'expires' : 365 , 'path' : '/'
			});
		} else {
			// Get user segment from previously stored cookie
			userSegment = jQuery.cookie('SCSUserSegment');
			if (typeof(userSegment) !== 'string') return;
			userSegment = userSegment.toLowerCase();
			handleLoginState(userSegment, false);
		}
	});
});

function getStorageKey(userSegment) {
	return 'SCS_' +
		userSegment.toUpperCase() +
		'_CALLOUT_CLOSED';
}

/** Check if user already saw the popup */
function sawDialog(userSegment, isLoggedIn) {

	var storageKey = getStorageKey(userSegment === 'res' ? 'res' : 'biz');
	// SessionStorage is cleared after UA close or new Tab
	var storageValue = !!sessionStorage.getItem(storageKey);
	// Users can only persist setting if they are not logged in.
	storageValue |= !isLoggedIn && !!localStorage.getItem(storageKey);

	// Disabled since cookie seems to be never set anywhere?
	// if (!storageValue && jQuery.cookie(storageKey) == '1') {
	// 	sessionStorage.setItem(storageKey, true)
	// 	return true;
	// }

	return storageValue;

}

/** Show dialog to chose to switch segments */
function showDialog(userSegment, isLoggedIn) {

	var $dialogLabels = jQuery('DIV.res-sme-cbu-callout');
	var labels = $dialogLabels.data("labels");
	var labelSegment = userSegment !== 'res' ? 'biz' : 'res';
	var storageKey = getStorageKey(labelSegment);

	// Suppress popup without having useful labels
	if ($dialogLabels.length == 0 || !labels) {
		return;
	}

	function i18n(name) {
		if (!labels[name]) return name;
		return labels[name][labelSegment] ||
			labels[name]['res'] ||
			labels[name] ||
			name;
	}

	function persitCloseState(canceled) {
		// Checkbox will only be available if user is not logged in
		// So in case user is logged in we always use sessionStorage
		if($checkbox.prop('checked')) {
			localStorage.setItem(storageKey, true);
		}
		// Always remember choice for session
		sessionStorage.setItem(storageKey, true);
	}

	var $wrapper = jQuery('<div class="checkbox checkbox--inverted"></div>')
	var $checkbox = jQuery('<input type="checkbox" id="dontShowAgain"></input>')
	var $label = jQuery('<label for="dontShowAgain"> ' + i18n('dontShowAgain') + '</label>');
	var $html = jQuery('<form>').append($wrapper.append($checkbox, $label));

	// Show SDXModalDialog
	modal.show({
		class: 'col-xs col-md-10 col-lg-8 col-xl-6',
		title: i18n('title'), text: i18n('message'),
		html: isLoggedIn ? undefined : $html,
		buttons: [{
			title: i18n('change'),
			primary: true,
			type: 'close'
		}, {
			title: i18n('close'),
			primary: false,
			type: 'cancel'
		}],
		on: {
			close: function() {
				persitCloseState(false);
				// defer to allow tracking
				setTimeout(function() {
					var getShopUrl = userBox['get' +
						userSegment.substr(0,1).toUpperCase() +
						userSegment.substr(1).toLowerCase() +
					'ShopUrl'];
					if (getShopUrl) {
						var url = getShopUrl.call(userBox);
						if (url) { document.location = url; }
					}
				}, 85);
				// Closed via "change segment" button
				trackDefered('button', 'change-cfu', 'cfu-suggestion');
			},
			cancel: function() {
				persitCloseState(true);
				// Closed via "cancel" or any other mean
				trackDefered('close', 'close cfu-suggestion', 'cfu-suggestion');
			}
		}
	});

	// Track the open event immediately (but wait for datalayer)
	trackDefered('open', 'open cfu-suggestion', 'cfu-suggestion');

}

/** Check if user should see the popup */
function wantsDialog(userSegment, isLoggedIn) {

	var $body = $(document.body);
	// Do not show popup on ent and home pages.
	if($('[data-is-exclude-popup="true"]').length) { return false; }
	if($('[data-is-level-null-page="true"]').length) { return false; }

	// We need to wait a little to fetch this?
	// AEM does something weird with body tag?
	var pageSegment = $body.data('page-segment');

	// Help page doesn't have pageSegment
	if (pageSegment == undefined) { return false; }
	// Checks taken exactly from previous code
	if (userSegment == undefined) { return false; }
	if (userSegment === 'undefined') { return false; }
	// Don't show when user is in correct segment
	if (userSegment === pageSegment) { return false; }

	// Print out a debug message
	var msg = 'res-sme-callout: logged';
	var state = isLoggedIn ? '-in' : '-out';
	debug.log(msg + state, userSegment, 'user in', pageSegment);

	// Do not show for SME-customers in CBU or CBU-customers in SME
	if (userSegment === Segment.SME && pageSegment === Segment.CBU) { return false; }
	if (userSegment === Segment.CBU && pageSegment === Segment.SME) { return false; }
	// Only show dialog for not logged in SME users (copied from cbu.js)
	if (userSegment !== Segment.SME && isLoggedIn === false) { return false; }

	// Show otherwise
	return true;

}

/** Called once login state is determined */
function handleLoginState(userSegment, isLoggedIn) {
	if (wantsDialog(userSegment, isLoggedIn)) {
		if (!sawDialog(userSegment, isLoggedIn)) {
			showDialog(userSegment, isLoggedIn);
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/res-sme-cbu-popup.js
// module id = 358
// module chunks = 0